<template>
  <div class="alert" v-if="visible">
    <slot></slot>
    <i class="alert__closebtn el-icon-close" @click="visible=!visible"></i>
  </div>
</template>
<script>
export default {
  name: 'cc-alert',
  data() {
    return {
      visible: true,
    };
  },
};
</script>
<style lang="scss" scoped>
.alert{
    text-align: right;
    font-size: 12px;
    color: #E6A23C;
    padding: 10px 0;
    &__closebtn{
      cursor:pointer;
      margin-left: 20px;
    }
  }
</style>
